import { documentHasElements } from "modules/dom";
import { isTrustedVideoUrl } from "helpers/validateUrl";

documentHasElements(".js-video-with-text-block", (videoBlocks) => {
    videoBlocks.forEach((videoBlock) => {
        const youtubeWrapper = videoBlock.querySelector<HTMLElement>(".youtube");
        if (!youtubeWrapper) return;

        const imageContainer = youtubeWrapper.querySelector<HTMLElement>(".image-container");
        const videoContainer = youtubeWrapper.querySelector<HTMLDivElement>(".video-container");
        const closeButton = youtubeWrapper.querySelector<HTMLButtonElement>(".video-container button");
        const embedUrl = youtubeWrapper.querySelector<HTMLElement>(".embed-url")?.textContent?.trim();

        let isPlaying = false;

        imageContainer?.addEventListener("click", () => {
            if (!embedUrl || isPlaying) return;
            if (!isTrustedVideoUrl(embedUrl)) return;
            isPlaying = true;

            // Create iframe immediately before switching visibility
            const iframe = document.createElement("iframe");
            const baseUrl = new URL(embedUrl);
            const src = baseUrl.origin + baseUrl.pathname + "?autoplay=1&rel=0&showinfo=0";
            iframe.setAttribute("src", src);
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
            iframe.setAttribute("allowfullscreen", "allowfullscreen");
            iframe.setAttribute("width", "100%");
            iframe.setAttribute("height", "100%");
            videoContainer?.appendChild(iframe);

            // Crossfade: both transitions start simultaneously, no layout flash
            imageContainer?.classList.add("played");
            videoContainer?.classList.add("played");
        });

        closeButton?.addEventListener("click", () => {
            const iframe = youtubeWrapper.querySelector<HTMLIFrameElement>("iframe");
            videoContainer?.classList.add("closed");

            setTimeout(() => {
                imageContainer?.classList.remove("played");
                videoContainer?.classList.remove("played");
                videoContainer?.classList.remove("closed");
                iframe?.remove();
                isPlaying = false;
            }, 600);
        });
    });
});